import React from "react";

/* ================= ROOT ================= */

export function Dialog({ open, onOpenChange, children }) {
  if (!open) return null;

  return (
    <div style={overlayStyle} onClick={() => onOpenChange(false)}>
      <div
        style={dialogStyle}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

/* ================= PARTS ================= */

export function DialogContent({ children }) {
  return <div style={contentStyle}>{children}</div>;
}

export function DialogHeader({ children }) {
  return <div style={headerStyle}>{children}</div>;
}

export function DialogTitle({ children }) {
  return <div style={titleStyle}>{children}</div>;
}

export function DialogDescription({ children }) {
  return <div style={descriptionStyle}>{children}</div>;
}

export function DialogFooter({ children }) {
  return <div style={footerStyle}>{children}</div>;
}

export function DialogClose({ onClick }) {
  return (
    <button
      onClick={onClick}
      style={closeStyle}
      aria-label="Close"
    >
      ✕
    </button>
  );
}

/* ================= STYLES ================= */

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000
};

const dialogStyle = {
  background: "white",
  borderRadius: "12px",
  width: "100%",
  maxWidth: "700px",
  maxHeight: "90vh",
  overflowY: "auto",
  boxShadow: "0px 10px 25px rgba(0,0,0,0.15)",
  position: "relative",
  animation: "fadeIn 0.15s ease-out"
};

const contentStyle = {
  padding: "16px 24px",
  position: "relative"
};

const headerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  marginBottom: "16px"
};

const titleStyle = {
  fontSize: "18px",
  fontWeight: 600,
  color: "#111827"
};

const descriptionStyle = {
  fontSize: "14px",
  color: "#64748b"
};

const footerStyle = {
  padding: "16px 24px",
  borderTop: "1px solid #e5e7eb",
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px"
};

const closeStyle = {
  position: "absolute",
  top: "12px",
  right: "12px",
  border: "none",
  background: "#f1f5f9",
  color: "#475569",
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
